module.exports = __webpack_public_path__ + "img/google-play-store-btn-DE.a7ff79f0.svg";